import { Injectable } from '@angular/core';
import { RewardsPreferenceFacade } from '@features/rewards-preference/facades/rewards-preference/rewards-preference.facade';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { AuthActionTypes } from '@rd/core/auth/store/actions/auth.actions';
import { take, tap } from 'rxjs/operators';

@Injectable()
export class ApplicationEffects {
  constructor(
    private actions$: Actions,
    private rewardsPreferenceFacade: RewardsPreferenceFacade,
  ) {}

  loginSuccess$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(AuthActionTypes.LOGIN_USER),
        take(1),
        tap(() => this.rewardsPreferenceFacade.loadRewardsPreference()),
      ),
    {
      dispatch: false,
    },
  );
}
